// extracted by mini-css-extract-plugin
module.exports = {"icon":"AttributeIconArea_icon__XDRKr"};